import { render, staticRenderFns } from "./CollectionLayoutLinear.vue?vue&type=template&id=18ca47d5&lang=pug&"
import script from "./CollectionLayoutLinear.vue?vue&type=script&lang=js&"
export * from "./CollectionLayoutLinear.vue?vue&type=script&lang=js&"
import style0 from "./CollectionLayoutLinear.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18ca47d5')) {
      api.createRecord('18ca47d5', component.options)
    } else {
      api.reload('18ca47d5', component.options)
    }
    module.hot.accept("./CollectionLayoutLinear.vue?vue&type=template&id=18ca47d5&lang=pug&", function () {
      api.rerender('18ca47d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/CollectionLayoutLinear.vue"
export default component.exports